import React, { Component } from 'react';
import { connect } from 'react-redux';
import VolontarioForm from './VolontarioForm';
import ConsumidorForm from './ConsumidorForm';
import { account_update } from '../../../redux/actions/accountActions';

class ProfileForm extends Component {

  render() {

    const { account, common } = this.props;
    console.log("---------",this.props)
    const type = account.data.account_type;
    return (
      <div>
        {
          type === "volunteer" ? <VolontarioForm account={account} common={common} /> : <ConsumidorForm account={account} common={common} />
        }
      </div>
    )
  }
}


ProfileForm = connect(state => ({
  auth: state.auth,
  common: state.common,
  account: state.account,

}))(ProfileForm)






export default ProfileForm;



// WEBPACK FOOTER //
// ./src/modules/account/forms/ProfileForm.js